export const overlayPendingIdKey = (overlayId: string) => `overlayId:${overlayId}`

/** See `.cursor/rules/platform-client-contracts.mdc` § Form XML Overlay / стартовая видимость. */
export function resolveFormOverlayInitialVisible(
  isDialog: boolean,
  pendingVisible?: boolean,
): boolean {
  if (pendingVisible !== undefined) return pendingVisible
  return !isDialog
}

export function setPendingOverlayVisibilityRecord(
  pending: Record<string, boolean>,
  name: string | undefined,
  overlayId: string | undefined,
  visible: boolean,
): void {
  if (name) pending[name] = visible
  if (overlayId) pending[overlayPendingIdKey(overlayId)] = visible
}

export function consumePendingOverlayVisibilityFromRecord(
  pending: Record<string, boolean>,
  name: string,
  overlayId: string,
): boolean | undefined {
  if (Object.prototype.hasOwnProperty.call(pending, name)) {
    const value = pending[name]
    delete pending[name]
    delete pending[overlayPendingIdKey(overlayId)]
    return value
  }
  const idKey = overlayPendingIdKey(overlayId)
  if (Object.prototype.hasOwnProperty.call(pending, idKey)) {
    const value = pending[idKey]
    delete pending[idKey]
    return value
  }
  return undefined
}
